export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSkladPneu';
export const NAME = 'SkladPneu';
